'use client';

import React, { useCallback } from 'react';
import { useClearRefinements } from 'react-instantsearch-core';

import { ClearRefinements as ClearRefinementsUiComponent } from './ClearRefinementsUI';

import type { ClearRefinementsProps as ClearRefinementsUiComponentProps } from './ClearRefinementsUI';
import type { UseClearRefinementsProps } from 'react-instantsearch-core';

type UiProps = Pick<ClearRefinementsUiComponentProps, 'disabled' | 'onClick' | 'translations'>;

export type ClearRefinementsProps = Omit<ClearRefinementsUiComponentProps, keyof UiProps> &
  UseClearRefinementsProps & {
    translations?: Partial<UiProps['translations']>;
    overrideDisabled?: boolean;
    onClick?: () => void;
  };

export function ClearRefinements({
  includedAttributes,
  excludedAttributes,
  transformItems,
  translations,
  overrideDisabled,
  onClick: onClickProps,
  ...props
}: ClearRefinementsProps) {
  const { canRefine, refine } = useClearRefinements(
    {
      includedAttributes,
      excludedAttributes,
      transformItems,
    },
    {
      $$widgetType: 'ais.clearRefinements',
    },
  );

  const onClickHandler = useCallback(() => {
    refine();
    onClickProps?.();
  }, [refine, onClickProps]);

  const uiProps: UiProps = {
    onClick: onClickHandler,
    disabled: overrideDisabled === undefined ? !canRefine : overrideDisabled && !canRefine,
    translations: {
      resetButtonText: 'Clear refinements',
      ...translations,
    },
  };

  return <ClearRefinementsUiComponent {...props} {...uiProps} />;
}
